import React, { Suspense } from 'react';
import Loader from 'components/Loader';

const SuspenseRouter = (props) => {

    if(props.serverRender) return props.children;

    return <Suspense fallback={<Loader />}>
        {props.children}
    </Suspense>
};

export default SuspenseRouter;
